var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRendelsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 40,
    viewBox: "0 0 54 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0624 4.5166C35.489 4.5166 42.583 12.209 42.583 19.7948C42.583 27.3805 35.489 35.0827 23.0624 35.0827C10.6358 35.0827 3.52246 27.3805 3.52246 19.7948C3.52246 12.209 10.6455 4.5166 23.0624 4.5166Z",
    fill: "#7C6CC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74173 11.8793L14.6518 6.6702C14.6518 6.6702 9.11601 0.413413 7.86754 0.956638C6.32874 1.55806 7.74173 11.8696 7.74173 11.8793ZM14.1873 6.6702L22.5781 10.3758C22.5781 10.3758 24.6299 0.811131 23.3137 0.0544968C21.9975 -0.702137 14.2163 6.6702 14.2163 6.6702H14.1873Z",
    fill: "#7C6CC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1416 18.5723C38.1416 18.5723 44.6549 20.4251 46.8518 17.9321C48.8455 15.6816 49.3778 11.3067 46.6679 10.0069C45.1001 9.25993 42.7193 10.3949 42.6225 12.1216C42.4774 14.7698 46.4937 15.8659 48.9616 15.0317C51.4295 14.1975 52.0005 9.21143 52.0005 9.21143",
    stroke: "#7C6CC9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4424 17.6509L0 16.6421L0.183882 26.4977L8.17793 26.0321L7.4424 17.6509Z",
    fill: "#7C6CC9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68164 18.1556C5.68164 15.2455 6.53331 14.062 7.1527 14.062C7.77209 14.062 8.61408 15.2552 8.61408 18.1556C8.61408 21.056 7.74306 22.2977 7.1527 22.2977C6.56234 22.2977 5.68164 21.1045 5.68164 18.1944M11.3917 18.1944C11.3917 15.2843 12.253 14.1008 12.8627 14.1008C13.4724 14.1008 14.3338 15.294 14.3338 18.1944C14.3338 21.0948 13.4821 22.2977 12.8627 22.2977C12.2433 22.2977 11.3917 21.0657 11.3917 18.1556V18.1944Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5656 28.4186C20.5656 28.4186 16.946 40.3696 15.3588 39.9912C14.391 39.7487 13.6265 32.1048 13.6265 32.1048C13.6265 32.1048 8.60357 38.5944 7.81965 38.2452C6.77443 37.8183 10.5489 27.4971 10.5585 27.4971L20.5656 28.4186Z",
    fill: "#7C6CC9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9084 25.3438C40.9084 25.3438 39.2535 38.8565 36.7759 38.5557C35.5564 38.4102 34.0176 32.2117 34.0176 32.2117C34.0176 32.2117 31.2304 39.3318 30.2335 39.1766C29.2367 39.0214 29.4206 30.1552 29.4206 30.1552L40.9084 25.3438Z",
    fill: "#7C6CC9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6371 8.10547H20.3721",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRendelsIcon);
export default __webpack_public_path__ + "static/media/RendelésIcon.4efdb4d47b27fb4bee77d5f6c2902841.svg";
export { ForwardRef as ReactComponent };